import { useCallback, useContext, useMemo, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";

import { dealerAdminToolsUpdate } from "../services/dealerServices";
import { updateAutoProcessAgreement } from "../services/tenantServices";
import { AuthContext } from "../AuthContext";
import JbwSwitch from "./JbwSwitch";
import CircularProgress from "@mui/material/CircularProgress";
import JBWDateLabel from "./JBWDateLabel";
import { AdminDealerSearch } from "./AdminDealerSearch";
import CustomNoRowsOverlay from "./gridNoRowOverLay";

const ST_DATA_PULL_OPTIONS = ["Completed", "Exported", "Posted"];
const STATUS_OPTIONS = ["Active", "InActive"];
export const DealerAdminTool = () => {
  const { user } = useContext(AuthContext);
  const [rows, setRows] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmPayload, setConfirmPayload] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [allDealersData, setAllDealersData] = useState(false);
  const [datePickerValues, setDatePickerValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [autoProcessLoading, setAutoProcessLoading] = useState({});

  const openConfirmation = useCallback((actionType, payload) => {
    setConfirmAction(actionType); // 'status' | 'stDataPull' | 'lastSyncDate'
    setConfirmPayload(payload); // Contains rowId and newValue and crmSystem
    setConfirmOpen(true);
  }, []);

  const handleConfirmAction = async () => {
    if (!confirmAction || !confirmPayload) return;
    setConfirmLoading(true);
    const { rowId, newValue ,crmSystem,tenantId} = confirmPayload;
    try {
      if (confirmAction === "Status") {
        const result = await dealerAdminToolsUpdate(
          rowId,
          "status",
          user.name,
          newValue,
          crmSystem,
          tenantId
        );
        console.log("Dealer Admin Tools update Status result :: ", result);
        if (result.data && result.data.affectedRows > 0) {
          console.log("confirm payload : ", confirmPayload);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.dealerId === rowId
                ? {
                    ...row,
                    status: newValue,
                  }
                : row
            )
          );
        }
      } else if (confirmAction === "STDataPull") {
        console.log("tenantId : ",confirmPayload);
        const result = await dealerAdminToolsUpdate(
          rowId,
          "invoice",
          user.name,
          newValue,
          crmSystem,
          tenantId
        );
        console.log("Dealer Admin Tools update STDataPull result :: ", result);
        if (result.data && result.data.affectedRows > 0) {
          console.log("confirm payload : ", confirmPayload);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.dealerId === rowId
                ? {
                    ...row,
                    invoiceStatus: newValue,
                  }
                : row
            )
          );
        }
      } else if (confirmAction === "LastSyncDate") {
        const result = await dealerAdminToolsUpdate(
          rowId,
          "lastsyncdate",
          user.name,
          newValue,
          crmSystem,
          tenantId
        );
        console.log(
          "Dealer Admin Tools update LastSyncDate result :: ",
          result
        );
        if (result.data && result.data.affectedRows > 0) {
          console.log("confirm payload : ", confirmPayload);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.dealerId === rowId
                ? {
                    ...row,
                    syncEndDate: newValue,
                  }
                : row
            )
          );
        }
        setLoading(false);
      } else if (confirmAction === "exceptiondays") {
        const result = await dealerAdminToolsUpdate(
          rowId,
          "exceptiondays",
          user.name,
          newValue,
          crmSystem,
          tenantId
        );
        console.log(
          "Dealer Admin Tools update exceptiondays result :: ",
          result
        );
        if (result.data && result.data.affectedRows > 0) {
          console.log("confirm payload : ", confirmPayload);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.dealerId === rowId
                ? {
                    ...row,
                    claimExceptionDays: newValue,
                  }
                : row
            )
          );
        }
        setLoading(false);
      } else if (confirmAction === "waitingperiod") {
        const result = await dealerAdminToolsUpdate(
          rowId,
          "waitingperiod",
          user.name,
          newValue,
          crmSystem,
          tenantId
        );
        console.log(
          "Dealer Admin Tools update waitingperiod result :: ",
          result
        );
        if (result.data && result.data.affectedRows > 0) {
          console.log("confirm payload : ", confirmPayload);
          setRows((prevRows) =>
            prevRows.map((row) =>
              row.dealerId === rowId
                ? {
                    ...row,
                    claimWaitingPeriod: newValue,
                  }
                : row
            )
          );
        }
        setLoading(false);
      }

      setConfirmOpen(false);
      setConfirmAction(null);
      setConfirmPayload(null);
    } catch (error) {
      console.error("Update failed:", error);
      setLoading(false);
    } finally {
      setConfirmLoading(false);
    }
  };

  const columns = useMemo(() => [
    {
      field: "dealerId",
      headerName: "DealerID",
      width: 75,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "dealerName",
      headerName: "Dealer Name",
      width: 110,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
        {
      field: "tenantId",
      headerName: "TenantID",
      width: 80,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
        {
      field: "tenantName",
      headerName: "Tenant Name",
      width: 110,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "crmSystem",
      headerName: "Platform",
      width: 80,
      sortable: false,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "date",
      headerName: "Created Date",
      width: 110,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (param) => {
        if (param.value === null) return "";
        return (
          <JBWDateLabel inputDate={param.value} dateFormat="MMM.DD.YYYY" />
        );
      },
    },
    {
      field: "claimExceptionDays",
      headerName: "ExceptionDays",
      width: 110,
      sortable: false,
      headerAlign: "center",
      editable: true,
      type: "number",
      align: "center",
    },
    {
      field: "claimWaitingPeriod",
      headerName: "WaitingPeriod",
      width: 110,
      sortable: false,
      headerAlign: "center",
      editable: true,
      type: "number",
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      width: 110,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: ({ value, row }) => {
        const getBgColor = (val) => {
          switch (val) {
            case "Active":
              return "#4caf50";
            case "InActive":
              return "#d4af37";
            default:
              return "#e0e0e0";
          }
        };

        return (
          <Select
            value={value}
            onChange={(e) =>
              openConfirmation("Status", {
                rowId: row.dealerId,
                newValue: value === "Active" ? "InActive" : "Active",
                crmSystem: row.crmSystem,
                tenantId:row.tenantId
              })
            }
            size="small"
            fullWidth
            sx={{
              backgroundColor: getBgColor(value),
              color: "#fff",
              borderRadius: "20px",
              fontWeight: 500,
              "& .MuiSelect-select": { padding: "6px 12px" },
            }}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },
    {
      field: "invoiceStatus",
      headerName: "ST Data Pull",
      width: 130,
      renderCell: ({ value, row }) => {
        const getBgColor = (val) => {
          switch (val) {
            case "Completed":
              return "#2e7d32"; // green
            case "Exported":
              return "#f9a825"; // yellow
            case "Posted":
              return "#0288d1"; // blue
            default:
              return "#e0e0e0"; // gray
          }
        };

        return (
          <Select
            value={value}
            onChange={(e) =>
              openConfirmation("STDataPull", {
                rowId: row.dealerId,
                newValue: e.target.value,
                crmSystem: row.crmSystem,
                tenantId:row.tenantId,
              })
            }
            size="small"
            fullWidth
            sx={{
              backgroundColor: getBgColor(value),
              color: "#fff",
              borderRadius: "20px",
              fontWeight: 500,
              "& .MuiSelect-select": { padding: "6px 12px" },
            }}
          >
            {ST_DATA_PULL_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        );
      },
    },
    {
      field: "autoProcessAgreement",
      headerName: "AutoProcess",
      width: 110,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: ({ value, row }) =>
        autoProcessLoading[row.dealerId] ? (
          <CircularProgress size={20} />
        ) : (
          <JbwSwitch
            setChecked={!!value}
            isChecked={(checked) => {
              setAutoProcessLoading((prev) => ({ ...prev, [row.dealerId]: true }));
              updateAutoProcessAgreement(row.tenantId, checked)
                .then(() => {
                  setRows((prevRows) =>
                    prevRows.map((r) =>
                      r.dealerId === row.dealerId
                        ? { ...r, autoProcessAgreement: checked }
                        : r
                    )
                  );
                })
                .catch((err) => {
                  console.error("AutoProcess update failed:", err);
                })
                .finally(() => {
                  setAutoProcessLoading((prev) => ({ ...prev, [row.dealerId]: false }));
                });
            }}
            id={`autoprocess-${row.dealerId}`}
          />
        ),
    },
    {
      field: "syncEndDate",
      headerName: "Last Sync Date",
      width: 230,
      renderCell: ({ row }) => {
        const selectedDate = datePickerValues[row.dealerId]
          ? datePickerValues[row.dealerId]
          : row.syncEndDate
          ? row.syncEndDate
          : null;

        return (
          <Box display="flex" alignItems="center" gap={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={new Date(selectedDate).toISOString().slice(0, 10)}
                onChange={(newDate) =>
                  setDatePickerValues((prev) => ({
                    ...prev,
                    [row.dealerId]: newDate?.format("MM/DD/YYYY") || "",
                  }))
                }
                format="YYYY/MM/DD"
                slotProps={{ textField: { size: "small" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "50px",
                      },
                      "& .MuiInputBase-input": {
                        height: "1.4375em",
                        padding: "5px 14px",
                      },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
            <Button
              variant="text"
              size="small"
              onClick={() =>
                openConfirmation("LastSyncDate", {
                  rowId: row.dealerId,
                  newValue: datePickerValues[row.dealerId] || row.syncEndDate,
                  crmSystem: row.crmSystem,
                  tenantId:row.tenantId,
                })
              }
            >
              Sync
            </Button>
          </Box>
        );
      },
    },
  ], [openConfirmation, datePickerValues, autoProcessLoading]);

  const QuickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter />
      </Box>
    );
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <AdminDealerSearch
          onSelect={(value, allDealersData) => {
            setAllDealersData(allDealersData);
            if (value && !allDealersData) {
              setRows([value]);
              setNoResults(false);
            } else {
              setRows([value]);
              setNoResults(true);
            }
          }}
        />
      </Box>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Update</DialogTitle>
        <DialogContent>
          {confirmAction === "Status" && (
            <>
              Changing the Status will effect all the tenants.
              <br />
              Are you sure you want to update the Status?
            </>
          )}

          {confirmAction === "STDataPull" && (
            <>Are you sure you want to update the Invoice Status?</>
          )}

          {confirmAction === "LastSyncDate" && (
            <>Are you sure you want to update the Last Sync Date?</>
          )}
          {confirmAction === "exceptiondays" && (
            <>Are you sure you want to update the Claim Exception Date?</>
          )}
          {confirmAction === "waitingperiod" && (
            <>Are you sure you want to update the Claim Waiting Period?</>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setConfirmOpen(false)}
            color="inherit"
            disabled={confirmLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmAction}
            color="primary"
            variant="contained"
            disabled={confirmLoading}
            startIcon={
              confirmLoading && <CircularProgress size={20} color="inherit" />
            }
          >
            {confirmLoading ? "Updating..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      {noResults ? (
        !allDealersData ? (
          <Typography variant="body1" color="red">
            No Dealer found with the give dealer Id.
          </Typography>
        ) : (
          <Typography variant="body1" color="red">
            Dealer is not onboarded.Please onboard the Dealer using the New
            OnBoarding Process
          </Typography>
        )
      ) : (
        <Box sx={{ height: 400 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => `${row.dealerId}`}
            processRowUpdate={(newRow, oldRow, fields) => {
              console.log("new row : ", newRow);
              console.log("Old row : ", oldRow);
              if (oldRow.claimExceptionDays !== newRow.claimExceptionDays) {
                openConfirmation("exceptiondays", {
                  rowId: newRow.dealerId,
                  newValue: newRow.claimExceptionDays,
                  crmSystem: newRow.crmSystem,
                  tenantId:newRow.tenantId,
                });
                const updateRow = {
                  ...newRow,
                }; // Update the row state to 'updated'.

                return updateRow;
              } else if (
                oldRow.claimWaitingPeriod !== newRow.claimWaitingPeriod
              ) {
                openConfirmation("waitingperiod", {
                  rowId: newRow.dealerId,
                  newValue: newRow.claimWaitingPeriod,
                  crmSystem: newRow.crmSystem,
                  tenantId:newRow.tenantId,
                });
                const updateRow = {
                  ...newRow,
                }; // Update the row state to 'updated'.

                return updateRow;
              }

              const updateRow = {
                ...newRow,
              }; // Update the row state to 'updated'.

              return updateRow;
            }}
            onProcessRowUpdateError={(error) => {
              console.log("error processing cell :", error);
            }}
            disableColumnFilter={true}
            disableColumnMenu={true}
            disableRowSelectionOnClick
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
              toolbar: QuickSearchToolbar,
            }}
          />
        </Box>
      )}
    </>
  );
};
